import { Box } from "@biblioteksentralen/react";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const DefaultPageLayout = (props: Props) => (
  <Box margin={{ base: "1rem 0 4rem", md: "1rem 0 8rem" }}>{props.children}</Box>
);
